import { CreateEmailVerificationCodeBySignerTokenRequest } from "./DocumentSign.dto";
import { DocumentSignerUrl } from "./DocumentSigner.url";
import { ApiReq } from "../common/flax.types";
import { extractKey, HttpRequest } from "../common/HttpRequest";
import { CreateUserVerificationCodeResponse } from "../sso/UserVerificationCode.dto";

export class DocumentSignerRest {
  public static async requestEmailVerificationCodeBySignerToken(
    req: ApiReq<CreateEmailVerificationCodeBySignerTokenRequest>
  ): Promise<CreateUserVerificationCodeResponse> {
    const authorization = extractKey(req, "authorization");
    const token = extractKey(req, "token");

    const resp = await HttpRequest.request<CreateUserVerificationCodeResponse>(
      process.env.MAVEN_DOCS_BE_URL || process.env.REACT_APP_DOCS_BE_URL,
      ...DocumentSignerUrl.requestEmailVerificationCodeBySignerToken(token),
      req,
      { authorization }
    );

    return resp.data;
  }
}
